<div class=" " *ngIf="showRequest" [class.read-only-content]="isReadOnly">
  <h2 class="sectionTitle" *ngIf="!isReadOnly">
    {{'FRONT_USER.QUALITY_REQUEST_FORM.HARDNESS_TEST_REQUEST_FORM_TITLE' | translate }}</h2>
   <!--request Details summary-->
   <app-request-details *ngIf="requestId" [baseRequest]="baseRequestDTO"></app-request-details>
   <!--request -->
  <!-- <div class="col-sm-6 offset-sm-3" > -->

  <form [formGroup]="addHardnessTestRequestForm"  *ngIf="!showSuccessMessage">

    <fieldset [disabled]="isReadOnly">
      <div class="form-container">
        <h4 class="section-title">{{ 'FRONT_USER.REQUEST_INFORMATION' | translate }}</h4>

        <!-- DesiredDate -->
        <div class="form-group">
          <!-- <span class="red"> *</span> --> <label
            for="DesiredDate">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.DESIRED_DATE' | translate}}</label>
            <span class="red"> *</span>
          <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="DesiredDate"
            [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', containerClass : 'theme-dark-blue' }">
          <div *ngIf="submitted ||(f.DesiredDate?.errors&&f.DesiredDate?.touched)" class="red ">
            <div *ngIf="f.DesiredDate?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
            <div *ngIf="f.DesiredDate?.errors?.inValidDateError">{{'FRONT_USER.DATE_ERROR' | translate}}</div>


          </div>

        </div>

        <!-- MeasurementUnitId -->
        <div class="form-group">
          <label for="MeasurementUnitId">{{'FRONT_USER.QUALITY_REQUEST_FORM.MEASUREMENT_UNIT' | translate}}</label>
          <span class="red"> *</span>
          <select id="measurementUnitId" name="measurementUnitId" class="form-control"
            formControlName="MeasurementUnitId">
            <option [value]="null" selected>{{'FRONT_USER.QUALITY_REQUEST_FORM.SELECT' | translate}}</option>
            <ng-container *ngFor="let unit of measurementUnits">
              <option *ngIf="displayedLang=='NameEN'" [value]="unit.Id">
                {{unit.NameEN}}
              </option>
              <option *ngIf="displayedLang=='NameAR'" [value]="unit.Id">
                {{unit.NameAR}}
              </option>
            </ng-container>
          </select>
          <div *ngIf="(submitted||f.MeasurementUnitId?.touched) &&(f.MeasurementUnitId?.errors||f.MeasurementUnitId?.value=='null')" class="red ">
            <div *ngIf="f.MeasurementUnitId?.errors?.required||f.MeasurementUnitId?.value=='null'">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
          </div>

        </div>

        <!-- NearestLocation -->
        <div class="form-group">
          <label id="example-radio-group-label">{{'FRONT_USER.Floating_Carnes_Request_Form.NearestLocation'|translate}}</label>
          <span class="red"> *</span>
          <div class="form-custom-inputs">
            <div class="custom-Radio"  *ngFor="let location of nearestLocationKeys;let i='index'">
              <input [id]="[location]"  type="radio"  name="NearestLocation"  [value]="nearestLocation[location]"
                 formControlName="NearestLocation" />
              <label [for]="[location]">{{'FRONT_USER.REPAIR_REQUEST_FORM.' + location | translate }}</label>
            </div>
          </div>
          <div *ngIf="submitted && f.NearestLocation?.errors" class="red ">
            <div *ngIf="f.NearestLocation?.errors?.required">
              {{'FRONT_USER.Floating_Carnes_Request_Form.ThisFieldIsRequired' | translate}}</div>
          </div>
        </div>

        <!-- Description -->
        <div class="form-group">
           <label
            for="Description">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.DESCRIPTION' | translate}}</label>
            <span class="red"> *</span>
          <textarea rows="4" cols="50" class="form-control" id="description" name="description"
            formControlName="Description"></textarea>
          <div *ngIf="submitted ||(f.Description?.errors&&f.Description?.dirty)" class="red ">
            <div *ngIf="f.Description?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
            <div *ngIf="f.Description?.errors?.maxlength">
              {{'FRONT_USER.REPAIR_REQUEST_FORM.WORK_DESCRIPTION_MAX_LENGTH_ERROR' | translate}}</div>
            <div *ngIf="f.Description?.errors?.startsWithSpaceError">{{'FRONT_USER.START_WITH_SPACE' | translate}}</div>

          </div>
        </div>

        <!-- MaterialType -->
        <!-- <div class="form-group">
          <span class="red"> *</span> <label
            for="MaterialType">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.MATERIAL_TYPE' | translate}}</label>
          <textarea  rows="4" cols="50" class="form-control" id="materialType" name="materialType"
            formControlName="MaterialType"></textarea>
          <div *ngIf="submitted ||(f.MaterialType?.errors&&f.MaterialType?.dirty)" class="red ">
            <div *ngIf="f.MaterialType?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
            <div *ngIf="f.MaterialType?.errors?.maxlength">{{'FRONT_USER.REPAIR_REQUEST_FORM.WORK_DESCRIPTION_MAX_LENGTH_ERROR' | translate}}</div>
          </div>
        </div>
      </div> -->

        <div class="form-group">
            <label
            for="MaterialType">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.MATERIAL_TYPE' | translate}}</label>
            <span class="red"> *</span>
          <input type="text" rows="4" cols="50" class="form-control" id="materialType" name="materialType"
            formControlName="MaterialType">
          <div *ngIf="submitted ||(f.MaterialType?.errors&&f.MaterialType?.dirty)" class="red ">
            <div *ngIf="f.MaterialType?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
            <div *ngIf="f.MaterialType?.errors?.maxlength"> {{'FRONT_USER.TEXT_MAX_LENGTH_50_ERROR' | translate}}</div>
          </div>
        </div>
      </div>


      <!-- DRAWINGS -->
      <div *ngIf="!isReadOnly">
        <div class="form-container">
          <h4 class="section-title">{{ 'FRONT_USER.Floating_Carnes_Request_Form.ATTACHMENTS' | translate}}</h4>
          <div class="form-group">
            <!-- <span class="red"> *</span> --> <label
              for="DrawingsFileInput">{{ 'FRONT_USER.QUALITY_REQUEST_FORM.DRAWINGS' | translate}}</label>
            <input type="file" accept=".pdf,.bmp,.doc,.docx,.gif,.jpg,.jpeg,.png" MaxSizeInMB="5" class="form-control"
              id="drawingsFileInput" name="drawingsFileInput" formControlName="DrawingsFileInput"
              (change)="onFileSelected($event,f.DrawingsFileInput,'Hardness_Test_Request_Drawings',12,'drawingsFileProgress','FRONT_USER.QUALITY_REQUEST_FORM.DRAWINGS')" />
            <div class="upload-info">
              <span>{{'FRONT_USER.Floating_Carnes_Request_Form.AllowedFileExtentionsTitle' | translate}}</span>
              <span>{{'FRONT_USER.Floating_Carnes_Request_Form.MaxFileSizeTitle' | translate}}</span>
            </div>
            <div *ngIf="submitted && f.DrawingsFileInput?.errors" class="red ">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              <!-- <div *ngIf="f.DrawingsFileInput?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div> -->
            </div>

            <!-- progress-bar -->
            <div class="progress">
              <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                [style.width]="drawingsFileProgress + '%'">
                <span class=""> {{drawingsFileProgress}} % Complete</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Titlt Of Attachment -->
      <div *ngIf="isReadOnly && drawingAttachmentExist">
        <div class="form-container">
          <h4 class="section-title">{{ 'FRONT_USER.Floating_Carnes_Request_Form.ATTACHMENTS' | translate}}</h4>

          <!-- Drawings in view mode -->
          <div class="form-group read-uploaded">
            <label>{{ 'FRONT_USER.QUALITY_REQUEST_FORM.EXECUTIVE_DRAWINGS' | translate}}</label>
            <a [attr.href]="drawingAttachmentUrl" target="_blank">
                <i class="icon-view-file"></i>
                {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}

            </a>
          </div>
        </div>
      </div>

      <!-- User Info -->
      <app-user-request-details [UserRequestDetailsformGroup]="addHardnessTestRequestForm" [IsReadOnly]="isReadOnly"
        [SubmitFlag]="submitted" [extrnalData]="userInfo" [IsCustomerName]="true"></app-user-request-details>

      <!-- TermsAndConditions -->
      <div class="form-group" *ngIf="!isReadOnly">
        <label for="TermsAndConditions">{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.TERMS_CONDITIONS' | translate }}</label>
        <span class="red"> *</span>
        <div class="custom-checkbox">
          <input type="checkbox" class="form-control" id="TermsAndConditions" name="TermsAndConditions"
            formControlName="TermsAndConditions" />
          <label for="TermsAndConditions">
              <a (click)="goToTermsAndConditions()" target="_blank" >{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.TERMS_CONDITIONS_Acceptence' | translate }}</a>
          </label>
        </div>
        <div *ngIf="submitted && f.TermsAndConditions?.errors" class="red ">
          <div *ngIf="f.TermsAndConditions?.errors?.required">
            {{ 'FRONT_USER.Floating_Carnes_Request_Form.Accpet_TermsAndConditions_Error_Message' | translate }}</div>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="form-group" *ngIf="!isReadOnly">
        <button Confirmation (confirmationClick)="onSubmit()" [disabled]="loading" type="submit"
          class="btn btn-primary SCAcustomBtn">{{ 'FRONT_USER.SAVE' | translate}}</button>
      </div>

    </fieldset>

  </form>
  <!-- </div> -->

</div>

<!-- Confirmation -->
<div *ngIf="!showRequest&&!isErrorMessage" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p> {{ 'FRONT_USER.SUCCESS_MESSAGE' | translate }}
    </p>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace"> {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>


<!-- error message -->
<div *ngIf="!showRequest&&isErrorMessage" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>

    </div>
</div>


<div *ngIf="requestId">
  <app-messaging></app-messaging>
</div>
